// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ba209d75","455":"d1ad2c88","977":"6ff66660"}[chunkId] + ".chunk.js";
};